const configs = {
  local: {
    env: 'local',
    backendUrl: 'http://localhost:8083',
    // backendUrl: 'http://formiq-dev-alb-1393233418.eu-central-1.elb.amazonaws.com',
    // backendUrl: 'https://demo.formpilot.de',
    // auth-login Lambda run locally via functions/auth-login/local_server.py
    // (see start-local.sh) — a different origin from backendUrl locally,
    // unlike in deployed envs where API Gateway puts both behind one domain.
    // Port 9001 is taken locally by MinIO's console, hence 9091.
    authUrl: 'http://localhost:9091',
  },
  production: {
    env: 'production',
    backendUrl: 'https://demo.formpilot.de',
    authUrl: 'https://demo.formpilot.de',
  },
};

const key = process.env.VUE_APP_ENV === 'local' ? 'local' : 'production';
export default configs[key];
